import { API, unwrapData } from '../axios-instance'

export type TenantPreferencesParams = {
  gifsEnabled?: boolean
}

export type MsTeamsPreferenceParams = {
  msTeamsEnabled: boolean
}

export type MyTenantPreferences = {
  msTeamsEnabled: boolean
  gifsEnabled: boolean
  tenantId: string
  createdAt: string
  updatedAt: string
  __entity_type__: 'tenantPreference'
}

export const getMyTenantPreferences = async () => {
  return await API.get<MyTenantPreferences>('/identity/tenantPreferences/my').then(unwrapData)
}

export const updateMyTenantPreferences = async (params: TenantPreferencesParams) => {
  return await API.put<MyTenantPreferences>('/identity/tenantPreferences', params).then(unwrapData)
}

export const updateMsTeamsPreference = async (params: MsTeamsPreferenceParams) => {
  return await API.put<MyTenantPreferences>('/identity/tenantPreferences/msTeams', params).then(
    unwrapData,
  )
}
